import { ComponentProps } from "react";

interface NatWestLogoProps extends ComponentProps<"svg"> {
  /**
   * Size of the logo in rem units
   */
  size?: number;
}

export const NatWestLogo = ({ size = 1.125, ...props }: NatWestLogoProps) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={`${size}rem`}
    height={`${size}rem`}
    viewBox="-271 75.9 196.6 170.3"
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n  .st0{fill:#FFFFFF;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{clip-path:url(#SVGID_8_);}\n\t.st4{clip-path:url(#SVGID_9_);fill:url(#SVGID_11_);}\n\t.st5{clip-path:url(#SVGID_2_);mask:url(#SVGID_3_);fill:url(#SVGID_12_);}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st7{clip-path:url(#SVGID_14_);}\n\t.st8{clip-path:url(#SVGID_20_);}\n\t.st9{clip-path:url(#SVGID_21_);fill:url(#SVGID_22_);}\n\t.st10{clip-path:url(#SVGID_14_);mask:url(#SVGID_10_);fill:url(#SVGID_23_);}\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st12{clip-path:url(#SVGID_25_);}\n\t.st13{clip-path:url(#SVGID_30_);}\n\t.st14{clip-path:url(#SVGID_31_);fill:url(#SVGID_32_);}\n\t.st15{clip-path:url(#SVGID_25_);mask:url(#SVGID_17_);fill:url(#SVGID_33_);}\n\t.st16{fill:#E40521;}\n\t.st17{fill:#D20A18;}\n "
      }
    </style>
    <g>
      <polygon
        className="st0"
        points="-186.7,246.2 -172.7,221.8 -158.6,246.2 -102.4,246.2 -102.4,246.2 -74.4,197.6 -102.5,148.9  -102.4,148.9 -130.6,148.9 -116.5,124.6 -144.6,75.9 -144.6,75.9 -200.8,75.9 -228.8,124.6 -214.7,148.9 -242.9,148.9 -271,197.6  -271,197.6 -271,197.6 -242.9,246.2 -186.8,246.2  "
      />
      <g>
        <g>
          <defs>
            <polygon
              id="SVGID_1_"
              points="-130.6,148.9 -144.6,173.2 -172.7,173.2 -186.7,197.6 -130.5,197.6 -102.4,148.9  "
            />
          </defs>
          <clipPath id="SVGID_2_">
            <use
              href="#SVGID_1_"
              style={{
                overflow: "visible",
              }}
            />
          </clipPath>
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter"
              filterUnits="userSpaceOnUse"
              x={-207.8}
              y={112.5}
              width={126.4}
              height={121.6}
            >
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
              />
            </filter>
          </defs>
          <mask
            maskUnits="userSpaceOnUse"
            x={-207.8}
            y={112.5}
            width={126.4}
            height={121.6}
            id="SVGID_3_"
          >
            <g className="st1">
              <g>
                <g>
                  <defs>
                    <polygon
                      id="SVGID_4_"
                      points="-130.6,148.9 -144.6,173.2 -172.7,173.2 -186.7,197.6 -130.5,197.6 -102.4,148.9  "
                    />
                  </defs>
                  <clipPath id="SVGID_5_" className="st2">
                    <use
                      xlinkHref="#SVGID_4_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                </g>
                <g>
                  <defs>
                    <polygon
                      id="SVGID_6_"
                      points="-130.6,148.9 -144.6,173.2 -172.7,173.2 -186.7,197.6 -130.5,197.6 -102.4,148.9  "
                    />
                  </defs>
                  <defs>
                    <rect
                      id="SVGID_7_"
                      x={-186.7}
                      y={124.6}
                      transform="matrix(-0.5 0.866 -0.866 -0.5 -66.8246 385.0931)"
                      width={84.2}
                      height={97.3}
                    />
                  </defs>
                  <clipPath id="SVGID_8_" className="st2">
                    <use
                      xlinkHref="#SVGID_6_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                  <clipPath id="SVGID_9_" className="st3">
                    <use
                      xlinkHref="#SVGID_7_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                  <linearGradient
                    id="SVGID_11_"
                    gradientUnits="userSpaceOnUse"
                    x1={-188.1683}
                    y1={-367.9488}
                    x2={-185.2356}
                    y2={-367.9488}
                    gradientTransform="matrix(14.3727 8.2981 -8.2981 14.3727 -514.4342 7010.9468)"
                  >
                    <stop
                      offset={0}
                      style={{
                        stopColor: "#1A1A1A",
                      }}
                    />
                    <stop
                      offset={0.1413}
                      style={{
                        stopColor: "#222222",
                      }}
                    />
                    <stop
                      offset={0.3718}
                      style={{
                        stopColor: "#3B3B3B",
                      }}
                    />
                    <stop
                      offset={0.6627}
                      style={{
                        stopColor: "#626262",
                      }}
                    />
                    <stop
                      offset={1}
                      style={{
                        stopColor: "#999999",
                      }}
                    />
                  </linearGradient>
                  <polygon
                    className="st4"
                    points="-176.2,57.8 -28.8,142.9 -113,288.8 -260.4,203.7  "
                  />
                </g>
              </g>
            </g>
          </mask>
          <linearGradient
            id="SVGID_12_"
            gradientUnits="userSpaceOnUse"
            x1={-188.1684}
            y1={-367.9488}
            x2={-185.2356}
            y2={-367.9488}
            gradientTransform="matrix(14.3727 8.2981 -8.2981 14.3727 -514.4332 7010.9473)"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#E40521",
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#E40521",
              }}
            />
          </linearGradient>
          <polygon
            className="st5"
            points="-165.6,112.5 -81.4,161.1 -123.5,234 -207.8,185.4  "
          />
        </g>
      </g>
      <g>
        <g>
          <defs>
            <polygon
              id="SVGID_13_"
              points="-228.8,124.6 -228.8,124.6 -214.7,148.9 -186.7,148.9 -172.7,173.2 -144.6,173.2 -172.7,124.6  "
            />
          </defs>
          <clipPath id="SVGID_14_">
            <use
              xlinkHref="#SVGID_13_"
              style={{
                overflow: "visible",
              }}
            />
          </clipPath>
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_1_"
              filterUnits="userSpaceOnUse"
              x={-252.8}
              y={83.1}
              width={132.2}
              height={131.6}
            >
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
              />
            </filter>
          </defs>
          <mask
            maskUnits="userSpaceOnUse"
            x={-252.8}
            y={83.1}
            width={132.2}
            height={131.6}
            id="SVGID_10_"
          >
            <g className="st6">
              <g>
                <g>
                  <defs>
                    <polygon
                      id="SVGID_15_"
                      points="-228.8,124.6 -228.8,124.6 -214.7,148.9 -186.7,148.9 -172.7,173.2 -144.6,173.2  -172.7,124.6  "
                    />
                  </defs>
                  <clipPath id="SVGID_16_" className="st7">
                    <use
                      xlinkHref="#SVGID_15_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                </g>
                <g>
                  <defs>
                    <polygon
                      id="SVGID_18_"
                      points="-228.8,124.6 -228.8,124.6 -214.7,148.9 -186.7,148.9 -172.7,173.2 -144.6,173.2  -172.7,124.6  "
                    />
                  </defs>
                  <defs>
                    <rect
                      id="SVGID_19_"
                      x={-232.4}
                      y={101}
                      transform="matrix(-0.6428 0.766 -0.766 -0.6428 -192.6697 387.6398)"
                      width={91.4}
                      height={95.8}
                    />
                  </defs>
                  <clipPath id="SVGID_20_" className="st7">
                    <use
                      xlinkHref="#SVGID_18_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                  <clipPath id="SVGID_21_" className="st8">
                    <use
                      xlinkHref="#SVGID_19_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                  <linearGradient
                    id="SVGID_22_"
                    gradientUnits="userSpaceOnUse"
                    x1={-138.0504}
                    y1={-370.1121}
                    x2={-135.1179}
                    y2={-370.1121}
                    gradientTransform="matrix(-10.0181 11.9394 -11.9394 -10.0181 -5970.8462 -1931.8749)"
                  >
                    <stop
                      offset={0}
                      style={{
                        stopColor: "#1A1A1A",
                      }}
                    />
                    <stop
                      offset={0.1413}
                      style={{
                        stopColor: "#222222",
                      }}
                    />
                    <stop
                      offset={0.3718}
                      style={{
                        stopColor: "#3B3B3B",
                      }}
                    />
                    <stop
                      offset={0.6627}
                      style={{
                        stopColor: "#626262",
                      }}
                    />
                    <stop
                      offset={1}
                      style={{
                        stopColor: "#999999",
                      }}
                    />
                  </linearGradient>
                  <polygon
                    className="st9"
                    points="-55.8,137.5 -175.2,279.8 -317.6,160.3 -198.2,18  "
                  />
                </g>
              </g>
            </g>
          </mask>
          <linearGradient
            id="SVGID_23_"
            gradientUnits="userSpaceOnUse"
            x1={-138.0504}
            y1={-370.1125}
            x2={-135.1179}
            y2={-370.1125}
            gradientTransform="matrix(-10.0181 11.9394 -11.9394 -10.0181 -5970.8462 -1931.8749)"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#E40521",
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#E40521",
              }}
            />
          </linearGradient>
          <polygon
            className="st10"
            points="-120.6,144.7 -179.4,214.7 -252.8,153.1 -194,83.1  "
          />
        </g>
      </g>
      <g>
        <g>
          <defs>
            <polygon
              id="SVGID_24_"
              points="-214.8,197.6 -186.7,246.2 -172.7,221.8 -186.7,197.6 -172.7,173.2 -186.7,148.9  "
            />
          </defs>
          <clipPath id="SVGID_25_">
            <use
              xlinkHref="#SVGID_24_"
              style={{
                overflow: "visible",
              }}
            />
          </clipPath>
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_2_"
              filterUnits="userSpaceOnUse"
              x={-262.7}
              y={128.2}
              width={138}
              height={138.8}
            >
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
              />
            </filter>
          </defs>
          <mask
            maskUnits="userSpaceOnUse"
            x={-262.7}
            y={128.2}
            width={138}
            height={138.8}
            id="SVGID_17_"
          >
            <g className="st11">
              <g>
                <g>
                  <defs>
                    <polygon
                      id="SVGID_26_"
                      points="-214.8,197.6 -186.7,246.2 -172.7,221.8 -186.7,197.6 -172.7,173.2 -186.7,148.9  "
                    />
                  </defs>
                  <clipPath id="SVGID_27_" className="st12">
                    <use
                      xlinkHref="#SVGID_26_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                </g>
                <g>
                  <defs>
                    <polygon
                      id="SVGID_28_"
                      points="-214.8,197.6 -186.7,246.2 -172.7,221.8 -186.7,197.6 -172.7,173.2 -186.7,148.9  "
                    />
                  </defs>
                  <defs>
                    <rect
                      id="SVGID_29_"
                      x={-244.6}
                      y={150.2}
                      transform="matrix(-0.6428 0.766 -0.766 -0.6428 -166.9307 473.0216)"
                      width={101.6}
                      height={94.8}
                    />
                  </defs>
                  <clipPath id="SVGID_30_" className="st12">
                    <use
                      xlinkHref="#SVGID_28_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                  <clipPath id="SVGID_31_" className="st13">
                    <use
                      xlinkHref="#SVGID_29_"
                      style={{
                        overflow: "visible",
                      }}
                    />
                  </clipPath>
                  <linearGradient
                    id="SVGID_32_"
                    gradientUnits="userSpaceOnUse"
                    x1={-180.4698}
                    y1={-368.7226}
                    x2={-177.5372}
                    y2={-368.7226}
                    gradientTransform="matrix(16.339 13.7104 -13.7104 16.339 -2320.2375 8679.7979)"
                  >
                    <stop
                      offset={0}
                      style={{
                        stopColor: "#1A1A1A",
                      }}
                    />
                    <stop
                      offset={0.1413}
                      style={{
                        stopColor: "#222222",
                      }}
                    />
                    <stop
                      offset={0.3718}
                      style={{
                        stopColor: "#3B3B3B",
                      }}
                    />
                    <stop
                      offset={0.6627}
                      style={{
                        stopColor: "#626262",
                      }}
                    />
                    <stop
                      offset={1}
                      style={{
                        stopColor: "#999999",
                      }}
                    />
                  </linearGradient>
                  <polygon
                    className="st14"
                    points="-205.7,60.3 -56.4,185.5 -181.8,334.9 -331.1,209.6  "
                  />
                </g>
              </g>
            </g>
          </mask>
          <linearGradient
            id="SVGID_33_"
            gradientUnits="userSpaceOnUse"
            x1={-180.4698}
            y1={-368.7228}
            x2={-177.5372}
            y2={-368.7228}
            gradientTransform="matrix(16.339 13.7104 -13.7104 16.339 -2320.2375 8679.7979)"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#E40521",
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#E40521",
              }}
            />
          </linearGradient>
          <polygon
            className="st15"
            points="-197.4,128.2 -124.8,189.1 -190.1,267 -262.7,206  "
          />
        </g>
      </g>
      <path
        className="st16"
        d="M-102.4,246.2L-102.4,246.2h-56.2l-28.1-48.7h56.2l28.1-48.6l28.1,48.6L-102.4,246.2z M-214.8,197.6 L-214.8,197.6l28.1-48.6h-56.2l-28.1,48.6l0,0l0,0l28.1,48.6h56.2h0L-214.8,197.6z M-144.6,76l28.1,48.6l-28.1,48.6l-28.1-48.7l0,0 h-56.2l28.1-48.6H-144.6z M-144.6,76L-144.6,76L-144.6,76z"
      />
      <path
        className="st17"
        d="M-102.5,148.9l28.1,48.6l-28.1,48.6l-28.1-48.7L-102.5,148.9z M-214.8,197.6H-271l0,0l28.1,48.6h56.2h0 L-214.8,197.6z M-172.7,124.6l28.1,48.7l28.1-48.6L-144.6,76L-172.7,124.6z"
      />
    </g>
  </svg>
);
